export default "__VITE_ASSET__B24L4e5i__"